import React from 'react';
import styled from 'styled-components';
import { colors, radii, fonts, getStatusStyle } from '../designSystem';

const StyledBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: ${radii.pill};
  font-family: ${fonts.body};
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
  background-color: ${(p) => p.$bg || colors.grisClair};
  color: ${(p) => p.$color || colors.textDark};
`;

/** Rating badge (green pastel with star) */
export function RatingBadge({ note, count }) {
  if (!note) return null;
  return (
    <StyledBadge $bg={colors.vertPastel} $color={colors.textDark}>
      <span style={{ marginRight: 4 }}>★</span>
      {note}
      {count != null && (
        <span style={{ fontWeight: 400, marginLeft: 4 }}>({count})</span>
      )}
    </StyledBadge>
  );
}

/** Status badge (dynamic color based on statut_etablissement) */
export function StatusBadge({ statut }) {
  if (!statut) return null;
  const style = getStatusStyle(statut);
  return (
    <StyledBadge $bg={style.bg} $color={style.color}>
      {statut === 'Ouvert' && '✓ '}
      {statut}
    </StyledBadge>
  );
}

/** Typologie badge (blue pastel) */
export function TypologieBadge({ typologie }) {
  if (!typologie) return null;
  const label = Array.isArray(typologie) ? typologie[0] : typologie;
  if (!label) return null;
  return (
    <StyledBadge $bg={colors.bleuPastel} $color={colors.bleuFonce}>
      {label}
    </StyledBadge>
  );
}

export default StyledBadge;
